import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'

const BankAccountMonthUI = ({context, loanBankAccountNum, bankAccountMonthList,
    onCreateClick, bankAccountNumber}) =>
  <div className='su_cf g_m_top_100'>
      {
        bankAccountMonthList.map((bam, i) =>
          <CardUI key={i} title={bam.monthF} className='g_m_top_100'>
            <div className='g_flex_h'>
              <span>Opening balance</span>
              <span><b>{bam.openingBalanceF5}</b></span>
            </div>
            <div className='g_m_top_50'>
            {
              bam.typeTotalF5List.filter(type => type.amountF5 !== '0.00').map((type, j) =>
                <div key={j} className='g_flex_h'>
                  <RowLeftUI type={type} />
                  <RowRightUI type={type} />
                </div>
              )
            }
            </div>
          </CardUI>
        )
      }
  </div>

  const RowLeftUI = ({context, type}) =>
    <span>
      {type.typeName}
    </span>

  const RowRightUI = ({type}) =>
    <span>
      {type.amountF5}
    </span>


export default BankAccountMonthUI
